
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/LandingPage",
      function () {
        return require("private-next-pages/LandingPage.js");
      }
    ]);
  